import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import * as _ from 'lodash';
import * as moment from 'moment';
import { environment } from './../../../../environments/environment';

import { TranslateService } from '@ngx-translate/core';
import { NzModalService, NzLocaleService, zhCN, enUS, zhTW } from 'ng-zorro-antd';

import { AuthService } from '../../../core/services/auth.service';
import { EnumService } from '../../../core/services/enum.service';
import { PreferencesService } from '../../../core/services/preferences.service';
import { LoginService } from '../../services/login.service';
import { UtilService } from '../../../core/services/util.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit, OnDestroy {
    // Observables
    destroyComponent$ = new Subject();  // Subject to Destroy Subscriptions
    get hasInquiry() {
        return environment.inquiry;
    }
    account = '';
    password = '';

    _currentLang;
    get currentLang() {
        return this._currentLang || 'zh-CN';
    }
    set currentLang(value) {
        this._currentLang = value;
        this.preferences.set('lang', value, true);
        if (value === 'zh-CN') {
            this._localeService.setLocale(zhCN);
        } else if (value === 'en-US') {
            this._localeService.setLocale(enUS);
        } else if (value === 'vi') {
            this._localeService.setLocale(zhCN);
        } else {
            this._localeService.setLocale(zhTW);
        }
        this.translate.use(value);
    }

    companyInfo: any;

    lang_options = [
        { label: '简体中文', value: 'zh-CN' },
        { label: '繁體中文', value: 'zh-TW' },
        { label: 'English', value: 'en-US' },
        { label: 'Tiếng Việt', value: 'vi' }
    ];

    // @ViewChild('loginModal')
    // private modal: ModalComponent;

    constructor(
        private service: LoginService,
        private translate: TranslateService,
        private enumService: EnumService,
        private preferences: PreferencesService,
        private modal: NzModalService,
        private auth: AuthService,
        private _localeService: NzLocaleService,
        private util: UtilService,
        private router: Router
    ) { }

    ngOnInit() {
        this.preferences.get('lang', true).then((value) => {
            this._currentLang = value || 'zh-CN';
        });

        this.service.getCompanyInfo().toPromise().then(x => {
            this.companyInfo = x[0];
        });

        Observable.fromEvent(document.querySelector('.onEnter'), 'keydown')
            // .takeUntil(this.destroyComponent$)
            .subscribe(event => {
                if (event && event['keyCode'] === 13) {
                    this.login();
                }
            });
    }

    ngOnDestroy(): void {
        this.destroyComponent$.next();
        this.destroyComponent$.complete();
    }

    update(input) {
        input.focus = true;
    }

    login() {
        const postbody = {
            vKey: '',
            vCode: '',
            loginName: this.account,
            password: this.util.jsonPre(this.password),
            lang: this.currentLang
        };
        // 直接访问用户系统接口
        this.service.login(postbody)
            .toPromise()
            .then(data => {
                if (data) {
                    this.preferences.userId = this.account;
                    sessionStorage.setItem('token', data['token']);
                    sessionStorage.setItem('userInfo', JSON.stringify(data['userInfo']));
                    this.enumService.verifyCacheVersion();
                    // // 登录后获取动态列定义
                    // this.meta.init();
                    // 保存语言偏好
                    this.currentLang = this.currentLang;

                    this.auth.redirectAfterLogin(!data.userInfo.oldLoginDate);
                }
            }, err => {

            });
    }

    enquiry() {
        this.router.navigate(['/price/enquiry-public'], {
            queryParams: { 'date': new Date().getTime() }
        });
    }

    get year() {
        return { year: moment().year() };
    }


    get website() {
        if (this.companyInfo) {
            if (_.startsWith(this.companyInfo.website, 'http://')) {
                return this.companyInfo.website;
            }
            return 'http://' + this.companyInfo.website;
        }
        return 'javascript://void(0);';
    }
}



// WEBPACK FOOTER //
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/home/components/login/login.component.ts